/* -------------------------------------------------------------------------- */
/*                               Schema Vehicles                              */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const vehicle = new schema.Entity('vehicles', {}, { idAttribute: 'vehicleId' });
export const vehicles = new schema.Array(vehicle);
